/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { GbGeschaeftId } from './gbGeschaeftId';
import { GrundbuchamtListEntryMeta } from './grundbuchamtListEntryMeta';
import { GrundstueckId } from './grundstueckId';
import { PersonStammMasterListEntryMeta } from './personStammMasterListEntryMeta';
import { TimePointListEntryMeta } from './timePointListEntryMeta';


export interface GrundbuchgeschaeftRestDetailEntryMeta { 
    anmelderText?: string;
    mAnmelderText?: FieldMetaData;
    anmelder?: Array<PersonStammMasterListEntryMeta>;
    mAnmelder?: FieldMetaData;
    egbtbid?: string;
    mEgbtbid?: FieldMetaData;
    zeitpunktRechtsgueltig?: Date;
    mZeitpunktRechtsgueltig?: FieldMetaData;
    ausgangTagebuch?: string;
    mAusgangTagebuch?: FieldMetaData;
    beschreibung?: string;
    mBeschreibung?: FieldMetaData;
    eCH0134GeneriertAm?: Date;
    mECH0134GeneriertAm?: FieldMetaData;
    eingangTagebuch?: Date;
    mEingangTagebuch?: FieldMetaData;
    meldungsrelevant?: GrundbuchgeschaeftRestDetailEntryMeta.MeldungsrelevantEnum;
    mMeldungsrelevant?: FieldMetaData;
    grundbuchmeldungRTFpossible?: boolean;
    mGrundbuchmeldungRTFpossible?: FieldMetaData;
    status?: GrundbuchgeschaeftRestDetailEntryMeta.StatusEnum;
    mStatus?: FieldMetaData;
    grundbuchmeldungPDFpossible?: boolean;
    mGrundbuchmeldungPDFpossible?: FieldMetaData;
    gbAmt?: GrundbuchamtListEntryMeta;
    mGbAmt?: FieldMetaData;
    id?: GbGeschaeftId;
    mId?: FieldMetaData;
    anmelderId?: Array<string>;
    mAnmelderId?: FieldMetaData;
    grundstueckIds?: Array<GrundstueckId>;
    mGrundstueckIds?: FieldMetaData;
    timePoint?: TimePointListEntryMeta;
    mTimePoint?: FieldMetaData;
    registraturText?: string;
    mRegistraturText?: FieldMetaData;
}
export namespace GrundbuchgeschaeftRestDetailEntryMeta {
    export type MeldungsrelevantEnum = 'JA' | 'NEIN' | 'UNBEKANNT';
    export const MeldungsrelevantEnum = {
        JA: 'JA' as MeldungsrelevantEnum,
        NEIN: 'NEIN' as MeldungsrelevantEnum,
        UNBEKANNT: 'UNBEKANNT' as MeldungsrelevantEnum
    };
    export type StatusEnum = 'TAGEBUCH' | 'TAGEBUCH_ABGESCHLOSSEN' | 'VORPRUEFUNG' | 'BEREIT_FUER_GRUNDBUCH' | 'HAUPTBUCH' | 'HAUPTBUCH_ABGESCHLOSSEN' | 'VERIFIKATION' | 'RECHTSGUELTIG' | 'RECHTSGUELTIG_AUSGETRAGEN' | 'SUSPENDIERT' | 'EXMATRIKULIERT' | 'PROVISORISCH_ABGEWIESEN' | 'REKURS' | 'REKURS_AKZEPTIERT' | 'ABGEWIESEN' | 'ABGEWIESEN_AUSGETRAGEN' | 'ZURUECKGEZOGEN' | 'ZURUECKGEZOGEN_AUSGETRAGEN';
    export const StatusEnum = {
        TAGEBUCH: 'TAGEBUCH' as StatusEnum,
        TAGEBUCHABGESCHLOSSEN: 'TAGEBUCH_ABGESCHLOSSEN' as StatusEnum,
        VORPRUEFUNG: 'VORPRUEFUNG' as StatusEnum,
        BEREITFUERGRUNDBUCH: 'BEREIT_FUER_GRUNDBUCH' as StatusEnum,
        HAUPTBUCH: 'HAUPTBUCH' as StatusEnum,
        HAUPTBUCHABGESCHLOSSEN: 'HAUPTBUCH_ABGESCHLOSSEN' as StatusEnum,
        VERIFIKATION: 'VERIFIKATION' as StatusEnum,
        RECHTSGUELTIG: 'RECHTSGUELTIG' as StatusEnum,
        RECHTSGUELTIGAUSGETRAGEN: 'RECHTSGUELTIG_AUSGETRAGEN' as StatusEnum,
        SUSPENDIERT: 'SUSPENDIERT' as StatusEnum,
        EXMATRIKULIERT: 'EXMATRIKULIERT' as StatusEnum,
        PROVISORISCHABGEWIESEN: 'PROVISORISCH_ABGEWIESEN' as StatusEnum,
        REKURS: 'REKURS' as StatusEnum,
        REKURSAKZEPTIERT: 'REKURS_AKZEPTIERT' as StatusEnum,
        ABGEWIESEN: 'ABGEWIESEN' as StatusEnum,
        ABGEWIESENAUSGETRAGEN: 'ABGEWIESEN_AUSGETRAGEN' as StatusEnum,
        ZURUECKGEZOGEN: 'ZURUECKGEZOGEN' as StatusEnum,
        ZURUECKGEZOGENAUSGETRAGEN: 'ZURUECKGEZOGEN_AUSGETRAGEN' as StatusEnum
    };
}


